<template>
  <div class="buyer-add-container">
    <b-row>
      <b-col :lg="8">
        <div class="form-container card drip-form-container">
          <div class="card-body">
            <h3 class="page-title section-title title-slash">
              {{ $t('buyers.add.business.title') }}
            </h3>
            <form
              @submit.prevent="submitBuyerForm"
              novalidate
              class="drip-form p-0"
            >
              <b-row>
                <b-col :sm="12">
                  <b-form-group
                    class="dc-group"
                    @mouseenter.native="hover('routing')"
                    @mouseleave.native="blur"
                  >
                    <label>
                      <span>{{ $t('buyers.add.form.routing') }}</span>
                    </label>
                    <b-form-radio-group
                      v-model="form.routing"
                      class="dc-radio"
                      :options="meta.DOCS_ROUTING"
                      stacked
                      v-validate="'required'"
                      @keyup.native="focus"
                      name="routing"
                    >
                      <span class="error">{{ errors.first('routing') }}</span>
                    </b-form-radio-group>
                  </b-form-group>
                  <help-text keyword="routing" :element="currentElement" />
                </b-col>
              </b-row>
              <b-row>
                <b-col :sm="12">
                  <b-form-group
                    class="dc-group"
                    @mouseenter.native="hover('release')"
                    @mouseleave.native="blur"
                  >
                    <label
                      ><span>{{ $t('buyers.add.form.release') }}</span></label
                    >
                    <b-form-radio-group
                      v-model="form.docs_release"
                      :options="meta.DOCS_RELEASE"
                      v-validate="'required'"
                      class="dc-radio"
                      stacked
                      @keyup.native="focus"
                      name="release"
                    >
                      <span class="error">{{ errors.first('release') }}</span>
                    </b-form-radio-group>
                  </b-form-group>
                  <help-text keyword="release" :element="currentElement" />
                </b-col>
              </b-row>
              <b-row>
                <b-col :sm="12">
                  <b-form-group
                    class="dc-group"
                    @mouseenter.native="hover('paymentTenor')"
                    @mouseleave.native="blur"
                  >
                    <label class="label independent">
                      <span>{{ $t('buyers.add.form.paymentTenor') }}</span>
                    </label>
                    <div class="form-ux flex-column flex-md-row">
                      <div class="form-ux-input">
                        <label
                          class="material-label"
                          :class="{ empty: form.payment_days === '' }"
                        >
                          <span>#</span>
                          <b-form-input
                            name="paymentDays"
                            type="number"
                            v-validate="'required'"
                            @focus.native="focus"
                            @blur.native="blur"
                            v-model="form.payment_days"
                          ></b-form-input>
                          <span class="error">{{
                            errors.first('paymentDays')
                          }}</span>
                        </label>
                      </div>
                      <div class="form-ux-text">
                        <label class="label independent">
                          <span>{{ $t('buyers.add.form.daysFrom') }}</span>
                        </label>
                      </div>
                      <div class="form-ux-fields">
                        <b-form-radio-group
                          v-model="form.payment_tenor"
                          :options="meta.TENOR_EVENTS"
                          v-validate="'required'"
                          class="dc-radio"
                          stacked
                          @keyup.native="focus"
                          name="paymentTenor"
                        >
                        </b-form-radio-group>
                      </div>
                    </div>
                  </b-form-group>
                  <help-text keyword="paymentTenor" :element="currentElement" />
                </b-col>
              </b-row>
              <b-row>
                <b-col :sm="12">
                  <div @mouseenter="hover('drip_limit')" @mouseleave="blur">
                    <label class="label independent">
                      <span>{{ $t('buyers.add.form.drip_limit') }}</span>
                    </label>
                    <div class="form-ux">
                      <b-form-group class="dc-group form-currency">
                        <b-dropdown
                          id="drip_limit"
                          :text="
                            form.currency.toUpperCase() || 'Select Currency'
                          "
                          variant="outline-secondary"
                          required
                        >
                          <b-dropdown-item
                            v-for="currency in meta.CURRENCY_VALUES"
                            @click.native="form.currency = currency.value"
                            :key="currency.value"
                          >
                            {{ currency.label }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-form-group>
                      <b-form-group class="form-limit dc-group">
                        <label
                          class="material-label"
                          :class="{ empty: form.drip_limit === '' }"
                        >
                          <span>#</span>
                          <b-form-input
                            name="limit"
                            type="number"
                            placeholder=""
                            @focus.native="focus"
                            @blur.native="blur"
                            v-validate="'required|is_not:0'"
                            v-model="form.drip_limit"
                          ></b-form-input>
                          <span class="error">{{ errors.first('limit') }}</span>
                        </label>
                      </b-form-group>
                    </div>
                  </div>
                  <help-text keyword="drip_limit" :element="currentElement" />
                </b-col>
              </b-row>
              <b-row>
                <b-col :sm="12">
                  <b-form-group
                    class="dc-group"
                    @mouseenter.native="hover('years_selling')"
                    @mouseleave.native="blur"
                  >
                    <label :class="{ empty: form.years_selling === '' }">
                      <span>{{ $t('buyers.add.form.experience') }}</span>
                    </label>
                    <b-dropdown
                      id="years_selling"
                      class="d-block"
                      :text="yearsText"
                      name="form[years_selling]"
                      variant="outline-secondary"
                      required
                    >
                      <b-dropdown-item
                        v-for="years in meta.YEARS_SELLING"
                        id="years_selling"
                        @click.native="form.years_selling = years.value"
                        :key="years.value"
                      >
                        {{ years.label }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <span class="error">{{
                      errors.first('years_selling')
                    }}</span>
                  </b-form-group>
                  <help-text
                    keyword="years_selling"
                    :element="currentElement"
                  />
                </b-col>
              </b-row>
              <form-button
                type="submit"
                variant="secondary"
                @click="stepChange('back')"
              >
                {{ $t('buyers.add.form.back') }}
              </form-button>
              <form-button :loading="loading" type="submit" variant="primary">
                {{ $t('buyers.add.form.submit') }}
              </form-button>
            </form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
.buyer-add-container {
  padding-bottom: 50px;
  span {
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 1.1px;
    font-family: $montserrat;
    text-transform: uppercase;
    &.error {
      color: $danger;
    }
  }
}
.form-ux {
  display: flex;
  .form-ux-input {
    flex: 2;
  }
  .form-ux-text {
    padding: 12px 15px;
    display: flex;
  }
  .form-ux-fields {
    flex: 4;
  }
  .form-currency {
    padding-right: 15px;
  }
  .form-limit {
    flex: 4;
  }
}
@include media-breakpoint-down(sm) {
  .row {
    border-bottom: 1px solid $gray-400;
    margin-bottom: 1rem;
  }
  .form-ux {
    flex-direction: column;
    .form-ux-input,
    .form-ux-text {
      padding-left: 0;
      padding-right: 0;
      label {
        padding-bottom: 0;
      }
    }
  }
}
</style>

<script>
import meta from '@/assets/application.india'
import FormButton from '@/components/common/FormButton'
import HelpText from '@/components/buyers/HelpText'
import buyersService from '@/services/buyers'

export default {
  data() {
    return {
      loading: false,
      meta: meta,
      booleanOptions: ['Yes', 'No'],
      payment_tenor_others: '',
      currentElement: ''
    }
  },
  mounted() {
    this.$mpTrack('Add Buyer - Buyer Operations page loaded')
    this.$emit('loadBuyer')
  },
  computed: {
    yearsText() {
      let item = this.meta.YEARS_SELLING.filter((item) => {
        return item.value === this.form.years_selling
      })
      return item.length > 0 ? item[0].label : 'Select Years'
    }
  },
  methods: {
    submitBuyerForm() {
      return this.$validator.validate().then((result) => {
        if (result) {
          return this.addBuyerBusiness()
        }
      })
    },
    stepChange(where) {
      if (where === 'back') {
        this.$mpTrack('Add Buyer - Go back to Buyer information')
        return this.$emit('prevStep')
      } else {
        this.$mpTrack('Add Buyer - Submit new buyer')
        return this.$emit('nextStep')
      }
    },
    focus(e) {
      this.blur()
      this.currentElement = !e.target ? e : e.target.name
    },
    hover(e) {
      this.currentElement = e
    },
    blur() {
      this.currentElement = ''
    },
    searchChange(sq, id) {
      this.form[id] = ' '
    },
    addBuyerBusiness() {
      this.loading = true
      return buyersService
        .modifyBuyersDraft(this.$route.params.buyerId, {
          draft: {
            task: 'customer_buyer_data',
            data: {
              buyer_form: this.form
            }
          }
        })
        .then((res) => {
          this.loading = false
          this.$mpTrack('Buyer Business Added Successfully')
          this.$notify({
            title: this.$t('notifications.buyerAdded.title'),
            text: this.$t('notifications.buyerAdded.text'),
            type: 'success'
          })
          this.stepChange()
          return this.$router.push({
            name: 'buyers'
          })
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  props: ['form'],
  components: {
    FormButton,
    HelpText
  },
  directives: {
    tabindex: {
      inserted(el) {
        el.setAttribute('tabindex', 0)
      }
    }
  }
}
</script>
